import React from "react";
import { useField, useFormikContext } from "formik";
import { MultiImagePreview } from "./MultiImagePreview";
import type { MultiImagePreviewProps, MultiImage } from "./MultiImagePreview";

interface FormikMultiImagePreviewProps
	extends Omit<
		MultiImagePreviewProps,
		"images" | "onChange" | "hasError" | "errorText"
	> {
	name: string;
}

export const FormikMultiImagePreview: React.FC<
	FormikMultiImagePreviewProps
> = ({ name, ...props }) => {
	const [field, meta] = useField<MultiImage[]>(name);
	const { setFieldValue } = useFormikContext();

	const hasError = !!(meta.error && meta.touched);

	const handleChange = (images: MultiImage[]) => {
		setFieldValue(name, images, true);
	};

	return (
		<MultiImagePreview
			{...props}
			images={field.value || []}
			onChange={handleChange}
			hasError={hasError}
			errorText={meta.touched ? (meta.error as string) : undefined}
		/>
	);
};
